import { statusItems } from '../helpers/data';

const betFilters = {
  status: [...statusItems],
};

export { betFilters };
